import React, { Component } from "react";
import RestaurantListItem from "../RestaurantListItem/RestaurantListItem.js";

class RestaurantList extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const tier1 = this.props.restaurants.filter(obj => {
      return obj.tierLevel === "Tier 1";
    });

    const tier1UserPaid = this.props.restaurants.filter(obj => {
      return obj.tierLevel === "Tier 1 (User Paid)";
    });

    const userPaid = this.props.restaurants.filter(obj => {
      return obj.tierLevel === "User Paid";
    });

    const tier2 = this.props.restaurants.filter(obj => {
      return obj.tierLevel === "Tier 2";
    });

    const sortedRestaurants = [
      ...tier1,
      ...tier1UserPaid,
      ...userPaid,
      ...tier2
    ];

    // console.log("sortedRestaurants==>>", sortedRestaurants);

    const restaurantItems = sortedRestaurants.map(restaurant => {
      return (
        <RestaurantListItem
          openLink={this.props.openLink}
          onRestaurantSelect={this.props.onRestaurantSelect}
          getSelectedRestaurantId={this.props.getSelectedRestaurantId}
          innerWidth={this.props.innerWidth}
          key={restaurant.id}
          restaurant={restaurant}
        />
      );
    });

    return <ul className="restaurant-list-group">{restaurantItems}</ul>;
  }
}

export default RestaurantList;
